export const EVENTS = {
	IMAGE_CLICKED: 'IMAGE_CLICKED'
}